// removed by extract-text-webpack-plugin
module.exports = {"List":"__wBce","ListItem":"_2Z6D4","Image":"_11Sao","ListItemActive":"_2a_oI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Meals/MealsSelect/MealsSelect.scss
// module id = 573
// module chunks = 0